/* unplugin-vue-components disabled */import { render } from "./LeftMenuItem.vue?vue&type=template&id=bc31230c&scoped=true"
import script from "./LeftMenuItem.vue?vue&type=script&lang=js"
export * from "./LeftMenuItem.vue?vue&type=script&lang=js"

import "./LeftMenuItem.vue?vue&type=style&index=0&id=bc31230c&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈工程-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc31230c"]])

export default __exports__